import React from "react";
import { useTranslation } from "react-i18next";

export const GoPOSSection = (): JSX.Element => {
	const { t } = useTranslation();

	return (
		<section className="gopos-info-section" data-testid="e-order-gopos-section">
			<img src="/graphics/logo.png" alt="GoPOS Logo" className="gopos-logo" />
			<div className="text-muted">
				{t("modules.e_order.field.gopos_info.title")}
				<div>
					<a href="https://gopos.pl/" target="_blank" rel="noreferrer">
						gopos.pl
					</a>
				</div>
			</div>
		</section>
	);
};
